<template>
  <div class="p-2">
    <LoadingSpinner :loading="isLoading" />
    <b-card
      v-if="!isLoading && Object.keys(item).length > 0"
      header="Default"
      class="bg-card-task"
    >
      <div slot="header">
        ‌
        <div class="float-left">
          <b> {{ name }}</b>
        </div>
      </div>
      <b-row>
        <div class="description-card-task">
          <div
            class="description-card-content"
            v-html="createPureDom(description)"
          ></div>
          <div :class="`d-flex ${action ? `p-80` : ``} `">
            <div
              class="ml-1"
              v-if="action.params && action.type == 'external_page'"
            >
              <b-link
                class="btn btn-primary"
                v-if="action.params.address"
                :disabled="statusTask == 1"
                target="_self"
                :href="action.params.address"
              >
                {{ action.caption }}
              </b-link>

              <router-link
                v-if="!action.params.address && !termStateCode"
                :disabled="statusTask == 1"
                class="btn btn-primary"
                :to="{ name: action.name, params: { ...action.params } }"
                >{{ action.caption }}
              </router-link>

              <router-link
                v-if="!action.params.address && termStateCode"
                :disabled="statusTask == 1"
                class="btn btn-primary"
                :to="{ name: action.name, params: { termStateCode } }"
                >{{ action.caption }}
              </router-link>
            </div>
            <div class="ml-1" v-if="action.type == 'internal_page'">
              <button
                v-if="action.name == `person_content`"
                :disabled="statusTask == 1"
                type="button"
                @click="addPersonContentModal(action)"
                class="btn btn-primary"
              >
                {{ action.caption }}
              </button>

              <button
                :disabled="statusTask == 1"
                v-if="includes(action.name, ['file', 'person_content'])"
                type="button"
                @click="openFileModal(action)"
                class="btn btn-primary"
              >
                {{ action.caption }}
              </button>
            </div>
            <div class="ml-1" v-if="action.type == 'service'">
              <b-button
                type="button"
                @click="callServies(action)"
                variant="primary"
                :disabled="isServies || statusTask == 1"
              >
                <b-spinner small v-if="isServies"></b-spinner>
                {{ action.caption }}
              </b-button>
            </div>
            <div class="ml-1" v-if="!action.params && action.name">
              <router-link
                :disabled="statusTask == 1"
                :to="{ name: action.name }"
                >{{ action.caption }}</router-link
              >
            </div>
          </div>
        </div>
        <b-col cols="12" md="12" class="mt-2">
          <UploadFile
            v-if="activityId && has_attachment"
            :keyServies="'activity'"
            :parentPermissions="parentPermissions"
            :keyValue="activityId"
            :file_types="file_types"
            :showAdd="false"
            :parentAttachmentTypeId="34"
            :outButton="activityFileButtons"
            :allowCollapse="true"
          />
        </b-col>
        <b-col cols="12" md="12">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="reset"
              class="mr-2"
              variant="outline-danger"
              @click="handleBack"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button
              type="button"
              v-if="!actionParamsKey.includes('center_execute_id')"
              variant="success"
              :disabled="statusTask == 1"
              @click="showConfirm"
            >
              <mdicon name="check" size="20" />
              {{ $lang.finishTask }}
            </b-button>
            <div class="float-left"></div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading && Object.keys(item).length == 0">
        {{ error }}
      </b-row>
    </b-card>
    <b-modal
      :title="$lang.search.columns_setting"
      variant="primary"
      hide-header
      hide-footer
      content-class="border-primary"
      size="xl"
      v-model="personDataModal"
      :ok-title="$lang.submitButton"
    >
      <addPersonContent
        :taskId="$route.params.id"
        :actionResource="actionResource"
        :actionkey="actionkey"
        @closeModal="cancel"
      />
    </b-modal>
    <b-modal
      no-close-on-backdrop
      hide-header
      hide-footer
      size="xl"
      v-model="sendFileModal"
    >
      <SendFileComponent
        :code="code"
        :attachmentTypeId="33"
        attachmentTypeName="attachment_type_person_content"
        @closeModal="sendFileModal = false"
      />
      <!-- <UploadFile
        v-if="!sendFileData.loading.loading"
        :keyServies="'task'"
        :keyValue="code"
        :file_types="file_types"
        :parentPermissions="parentPermissions"
        :showAdd="true"
        :showForm="false"
        :parentAttachmentTypeId="33"
        :outParams="{ 'attachment_type_id[]': 33 }"
        attachment_type_name="attachment_type_person_content    "
      />
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" @click="sendFileModal = false">
          <mdicon name="close" size="20" />
          {{ $lang.cancelButton }}
        </b-button>
      </template> -->
    </b-modal>
    <confirm
      :title="modalTitle"
      :description="message"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      :loading="isLoading"
      :loadingSpinnerText="$lang.updating_data"
      @ok="okConfirm"
      @cancel="cancelConfirm"
    ></confirm>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import addPersonContent from "./../personContent/addPersonContent";
import UploadFile from "@/components/base/uploadFile";
import confirm from "@/components/base/confirm";
import SendFileComponent from "../forms/sendFileComponent.vue";
import { mapState } from "vuex";
import { pathOr, includes } from "ramda";
import { mapActions } from "vuex";
import { createPureDom } from "@/shared/utils";

export default {
  name: "show-user-task",
  components: {
    LoadingSpinner,
    UploadFile,
    confirm,
    addPersonContent,
    SendFileComponent,
  },
  inject: ["taskShowRepository"],
  computed: {
    ...mapState("profile", ["userInfo"]),
    termStateCode() {
      const actionName = pathOr(null, ["name"], this.action);
      const payload =
        actionName === "payment" ? pathOr([], ["payload"], this.action) : [];
      let code = null;
      for (const item of payload) {
        const term_state_code = pathOr(null, ["term_state_code"], item);
        if (term_state_code) {
          code = term_state_code;
        }
      }
      return code;
    },
  },
  data() {
    return {
      code: this.$route.params.id,
      isLoading: false,
      isServies: false,
      animated: false,
      item: {},
      parentPermissions: [],
      actionResource: null,
      azmoonExecutePersonCode: null,
      actionkey: null,
      personDataModal: false,
      sendFileModal: false,
      duration: null,
      user_options: [],
      has_attachment: false,
      activityId: null,
      actionParamsKey: [],
      userSelected: null,
      show_at: null,
      end_at: null,
      action: null,
      name: null,
      description: null,
      taskId: null,
      finishTask: 0,
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: "", // عنوان مدال
      message: "", // نمایش متن حذف فایل,
      file_types: ["image", "office", "media", "other"],
      error: null,
      time_task_open: null,
      diff_duration: null,
      setInterval: null,
      def_month: null,
      def_day: null,
      hour_count: "",
      min_count: "",
      day_count: "",
      activityFileButtons: [
        {
          id: "1",
          name: "edit",
        },
        {
          id: "1",
          name: "download", // دانلود
          href: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions(["getParvandehStatus"]),
    pathOr,
    includes,
    createPureDom,
    async getDateTime() {
      try {
        const response = await this.$httpService.get(
          this.$config.api_url + this.$config.resources.date
        );
        let data = response.data.data;

        this.time_task_open = data.jalali_time;

        this.taskTimeToExecute(this.end_at.jalali, data.jalali_date_time);
      } catch (error) {
        this.$generateError(error);
      }
    },
    taskTimeToExecute(end_time, start_time) {
      if (start_time && end_time) {
        // date
        let end_task_date = end_time.split(" ")[0];
        let end_year = end_task_date.split("/")[0];
        let end_month = end_task_date.split("/")[1];
        let end_day = end_task_date.split("/")[2];
        // time
        let end_task_time = end_time.split(" ")[1];
        let end_hours = end_task_time.split(":")[0];
        let end_Minutes = end_task_time.split(":")[1];
        let end_seconds = end_task_time.split(":")[2];
        //new Date(year, month, day, hours, minutes, seconds, milliseconds)
        let end = new Date(
          end_year,
          end_month,
          end_day,
          end_hours,
          end_Minutes,
          end_seconds
        );

        // date
        let start_task_date = start_time.split(" ")[0];
        let start_year = start_task_date.split("/")[0];
        let start_month = start_task_date.split("/")[1];
        let start_day = start_task_date.split("/")[2];
        //  time
        let start_task_time = start_time.split(" ")[1];
        let start_hours = start_task_time.split(":")[0];
        let start_Minutes = start_task_time.split(":")[1];
        let start_seconds = start_task_time.split(":")[2];
        //new Date(year, month, day, hours, minutes, seconds, milliseconds)
        let start = new Date(
          start_year,
          start_month,
          start_day,
          start_hours,
          start_Minutes,
          start_seconds
        );

        //محاسبه اختلاف زمان شرع و پایان
        var diff_milli_secends = end.getTime() - start.getTime();

        let minutes = Math.floor(diff_milli_secends / 60000);
        // محاسبه به ساعت
        let Hours = Math.floor(minutes / 60);
        // باقی مانده زمان که همان دقیق می باشد

        let def_month = end_month - start_month;
        let def_day = end_day - start_day;
        this.def_month = def_month;

        let diff_minutes = minutes - Hours * 60; // اختلاف دقیقه
        if (diff_milli_secends > 0) {
          this.def_day = Hours > 24 ? def_day : "";
          Hours = this.def_day * 24 - Hours;
          this.day_count = this.def_day;
          this.min_count = this.checkTime(diff_minutes);
          this.hour_count = Hours;
          this.clock(this.hour_count, this.min_count, this.day_count);
        } else {
          this.diff_duration = this.$lang.task_time_out;
        }
      }
    },
    clock(Hours, minutes, def_day) {
      let min = minutes;
      let hour = Hours;
      let day = def_day;
      this.setInterval = setInterval(() => {
        if (min == 0) {
          min = 60;
        }
        if (min !== 0) {
          min = min - 1;
        }
        if (hour > 0 && min == 0) {
          hour = hour - 1;
        }
        if (min == 0 && hour == 0) {
          day = day - 1;
          hour = 24;
          min = 60;
        }
        this.day_count = day;
        this.min_count = this.checkTime(min);
        this.hour_count = hour;
      }, 60000);
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      } // add zero in front of numbers < 10
      return i;
    },
    defDaAndMonth(time_task_open) {
      let end_task = this.end_at && this.end_at.jalali.split(" ")[0];
      let task_open = time_task_open && time_task_open.split(" ")[0];
      let month_start = task_open.split("/")[1];
      let day_end = end_task.split("/")[2];
      let month_end = end_task.split("/")[1];
      let day_start = task_open.split("/")[2];
      let def_month = month_end - month_start;
      let def_day = day_end - day_start;
      this.def_month = def_month;
      this.def_day = def_day;
    },
    nextTask() {
      this.$router.push({
        name: "showUserTask",
        params: {
          id: this.item.next,
        },
      });
    },
    prevTask() {
      this.$router.push({
        name: "showUserTask",
        params: {
          id: this.item.prev,
        },
      });
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    showConfirm() {
      this.confirmModal = true;
      this.modalTitle = this.$lang.finishTask;
      this.message = this.$lang.finish_task_tooltip;
    },
    async callServies(action) {
      let payload = {};
      this.isServies = true;
      if (action.payload) {
        action.payload.map((val) => {
          let key = Object.keys(val);
          payload[key] = val[key];
        });
      }

      if (action.service_type == "get") {
        try {
          const response = await this.$httpService.get(action.url);
          this.$notify.success(response.data.message);
        } catch (error) {
          this.$generateError(error);
        } finally {
          this.isServies = false;
        }
      }
      if (action.service_type == "patch") {
        try {
          const actionUrl =
            action.url.charAt(0) === "/" ? action.url.substring(1) : action.url;
          const url = this.$config.api_url + actionUrl;
          await this.$httpService.patch(url, payload);
          if (action.complete_task) this.okConfirm();
        } catch (error) {
          this.$generateError(error);
        } finally {
          this.isServies = false;
        }
      }
      if (action.service_type == "put") {
        try {
          const response = await this.$httpService.put(action.url, payload);
          this.$notify.success(response.data.message);
        } catch (error) {
          this.$generateError(error);
        } finally {
          this.isServies = false;
        }
      }
      if (action.service_type == "post") {
        try {
          const response = await this.$httpService.post(action.url, payload);
          this.$notify.success(response.data.message);
        } catch (error) {
          this.$generateError(error);
        } finally {
          this.isServies = false;
        }
      }
    },
    addPersonContentModal(action) {
      this.personDataModal = true;
      this.actionResource = pathOr(null, ["params", "resource"], action);
      this.azmoonExecutePersonCode = pathOr(
        null,
        ["params", "azmoon_execute_person_code"],
        action
      );
      this.actionkey = pathOr(null, ["params", "key"], action);
    },
    async openFileModal(action) {
      this.actionResource = pathOr(null, ["params", "resource"], action);
      this.azmoonExecutePersonCode = pathOr(
        null,
        ["params", "azmoon_execute_person_code"],
        action
      );
      this.actionkey = pathOr(null, ["params", "key"], action);
      this.sendFileModal = true;
    },
    /**
     * @vuese
     * پاک کردن پیغام تایید پاک کردن
     *  @arg  بدون پارامتر
     */
    clearModalConfirm() {
      this.modalTitle = "";
    },
    /**
     * @vuese
     * قبول کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    async okConfirm() {
      this.isLoading = true;
      try {
        let payload = {
          status: 1,
        };
        let url =
          this.$config.api_url + this.$config.resources.task + "/" + this.code;
        const response = await this.$httpService.patch(url, payload);
        await this.getParvandehStatus(null);
        this.$notify.success(response.data.message);
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
        this.cancelConfirm();
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * @vuese
     * لغو کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    cancelConfirm() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    openModalInformation(action) {
      this.actionResource = action.actionResource;
      this.actionkey = action.actionkey;
      this.personDataModal = action.modal;
    },
    cancel() {
      this.personDataModal = false;
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save(payload) {
      this.isLoading = true;

      let id = this.$route.params.id;
      try {
        let res = await this.taskShowRepository.edit(id, payload);
        this.$notify.success(res.data.message);
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await this.taskShowRepository.find(this.code);
        this.parentPermissions = response.data.permissions;
        this.item = pathOr(null, ["data", "data"], response);
        this.statusTask = pathOr(null, ["status", "id"], this.item);
        this.duration = pathOr(null, ["duration"], this.item);

        this.show_at = pathOr(null, ["show_at"], this.item);
        this.end_at = pathOr(null, ["end_at"], this.item);
        this.has_attachment = pathOr(null, ["has_attachment"], this.item);
        this.activityId = pathOr(null, ["activity_id"], this.item);

        this.action = pathOr(null, ["actions"], this.item);
        const params = pathOr([], ["actions", "params"], this.item);
        if (params.length) {
          this.actionParamsKey = Object.keys(params).flat();
        }

        this.taskId = pathOr(null, ["code"], this.item);
        this.name = pathOr(null, ["name"], this.item);
        this.description = createPureDom(
          pathOr(null, ["description"], this.item)
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
        this.getDateTime();
      }
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.fetchData();
    },
    diff_duration(data) {
      this.animated = true;
      if (data == "0:00") {
        window.clearInterval(this.setInterval);
        this.diff_duration = this.$lang.task_time_out;
        this.$notify.warning(this.$lang.task_time_out);
      }
      this.animated = false;
    },
  },
};
</script>

<style>
.btn-link-user {
  padding: 6px;
  background: #20a8d8;
  color: white;
  border-radius: 4px;
  margin: 5px 0;
}

.bg-card-task {
  background: #e9ecef;
}

.description-card-task {
  width: 100%;
  background: white;
  margin: 0 16px 16px 16px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.description-card-content {
  padding: 10px 80px;
}
.description-card-content > p {
  margin: 0 !important;
}
.description-card-task > p {
  margin: 0 !important;
}

.p-80 {
  padding: 10px 80px;
}

button.bg-white {
  color: #fff !important;
  background-color: #20a8d8 !important;
  border-color: #20a8d8 !important;
}

button.bg-white:hover {
  color: #fff !important;
  background-color: #207fa0 !important;
  border-color: #207fa0 !important;
}

@-webkit-keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

.shake {
  -webkit-animation-name: shake;
  animation-name: shake;
}
</style>
